<template>
  <div class="wheel-page" v-if="img_start_ready">
    <div v-if="video_is_ready">
      <div v-show="run_video_play">
        <video
            preload="auto"
            playsinline
            ref="winner_video_loaded"
            width="100%">
          <source :src=winner_video_mp4 type="video/mp4">
        </video>
      </div>

      <div v-show="!run_video_play">
        <img :src=img_start_jpg width="100%"/>
      </div>
    </div>
    <div v-else>
      <!--        Video not loaded yet ready-->
      <img :src=img_start_jpg width="100%"/>
    </div>

    <div class="entry-card" v-if="show_input_fields">
      <label class="field-label" for="name">Name</label>
      <div class="pill-field">
        <input
            type="text"
            class="input__lg"
            id="name"
            v-model="full_name"
            name="name"
            placeholder="First and last"
            autocomplete="name"
        />
      </div>

      <label class="field-label" for="phone">Phone</label>
      <div class="pill-field">
        <input
            type="tel"
            class="input__lg"
            id="phone"
            v-model="phone"
            @blur="scrollToTop()"
            name="phone"
            placeholder="(310) 555-0123"
            autocomplete="tel"
        />
      </div>

      <div class="field-label">Send winning $ to</div>
      <div class="method-list">
        <button type="button" class="method-row" :class="{ on: payout_method === 'Venmo' }" @click="pick_method('Venmo')">Venmo</button>
        <button type="button" class="method-row" :class="{ on: payout_method === 'Cash App' }" @click="pick_method('Cash App')">Cash App</button>
      </div>
      <div class="pill-field" v-if="payout_method">
        <span class="pill-prefix">{{payout_method === 'Cash App' ? '$' : '@'}}</span>
        <input
            type="text"
            ref="payout_handle"
            v-model="payout_handle"
            :placeholder="payout_method === 'Cash App' ? 'cashtag or phone' : 'your-venmo'"
            autocomplete="off"
            autocapitalize="off"
            autocorrect="off"
        />
      </div>

      <button
          v-if="spin_wheel_button_ready && !instagram_opened"
          type="button"
          class="action-btn"
          @click="open_instagram">
        Follow @frootinsiders to spin <span class="action-arrow">↗</span>
      </button>

      <div
          v-if="spin_wheel_button_ready && instagram_opened && !instagram_returned"
          class="wait-note">
        Please follow, then come back here to spin.
      </div>

      <button
          v-if="spin_wheel_button_ready && instagram_returned"
          type="button"
          class="action-btn"
          @click="spin_the_wheel">
        Spin The Wheel
      </button>

      <div class="form-error" v-if="error_msg_line1">
        {{error_msg_line1}}<br>{{error_msg_line2}}
      </div>
    </div>
  </div>
  <div v-else>
    <splashScreen></splashScreen>
  </div>

</template>


<script>
import * as api from '@/api'

import splashScreen from '../components/splashScreen';

const INSTAGRAM_URL = 'https://www.instagram.com/frootinsiders/';

export default {
  name: 'WheelPage',
  components: {
    splashScreen
  },
  data() {
    return {
      full_name: '',
      phone: '',
      payout_method: '',
      payout_handle: '',
      error_msg_line1: '',
      error_msg_line2: '',
      spin_response: [],
      showPriceTimer: null,
      img_start_jpg: null,
      img_start_ready: false,
      img_end_jpg: null,
      img_end_ready: false,
      winner_video_mp4: null,
      video_is_ready: false,
      video_length_secs: null,
      my_var: null,
      run_video_play: false,
      show_input_fields: false,
      show_good_luck: false,
      spin_wheel_button_ready: false,
      instagram_opened: false,
      instagram_returned: false,
    };
  },
  props: {
    code: null,
    valid: null,
    id_number: null,
    img_start: null,
    img_end: null,
    winner_video_code: null,
  },
  mounted() {
    this.load_graphics();
    document.addEventListener('visibilitychange', this.on_visibility_change);
    window.addEventListener('focus', this.on_window_focus);
  },
  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.on_visibility_change);
    window.removeEventListener('focus', this.on_window_focus);
  },
  watch: {
    full_name: async function() {
      this.check_spin_wheel_ready();
    },
    phone: async function() {
      this.check_spin_wheel_ready();
    },
    video_is_ready: async function() {
      this.check_spin_wheel_ready();
    },
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0,0);
    },
    pick_method(method) {
      this.payout_method = method;
      this.$nextTick(() => {
        if (this.$refs.payout_handle) {
          this.$refs.payout_handle.focus();
        }
      });
    },
    check_spin_wheel_ready () {
      let digits = this.phone.match(/\d/g);
      let name_phone_ok = this.full_name.length >= 2 && digits && digits.length===10;

      this.spin_wheel_button_ready = name_phone_ok && this.video_is_ready;
      if(name_phone_ok) {
        this.error_msg_line1 = '';
        this.error_msg_line2 = '';
        if(!this.video_is_ready) {
          this.error_msg_line1 = 'Please wait ...';
          this.error_msg_line2 = '';
        }
      } else {
        this.error_msg_line1 = "Please enter your name and"
        this.error_msg_line2 = "phone number.";
      }
    },
    open_instagram () {
      this.instagram_opened = true;
      window.open(INSTAGRAM_URL, '_blank');
      api.stageLog({code: this.code, stage: 20});
    },
    mark_instagram_returned () {
      if (this.instagram_opened && !this.instagram_returned) {
        this.instagram_returned = true;
        api.stageLog({code: this.code, stage: 30});
      }
    },
    on_visibility_change () {
      if (document.visibilityState === 'visible') {
        this.mark_instagram_returned();
      }
    },
    on_window_focus () {
      this.mark_instagram_returned();
    },
    load_graphics() {
      api.stageLog({code: this.code, stage: 10});
      api.getWinnerVideo({vcode: this.img_start}).then(data => {
        this.img_start_jpg   = data.data;
        this.img_start_ready = true;
        if(this.img_start_jpg.length > 1000) {
          this.show_input_fields = true;
          api.stageLog({code: this.code, stage: 15});
        }
      })
      api.stageLog({code: this.code, stage: 11});
      api.getWinnerVideo({vcode: this.winner_video_code}).then(data => {
        this.winner_video_mp4 = data.data;
        this.video_is_ready   = true;
        api.stageLog({code: this.code, stage: 16});
      })
      api.getWinnerVideo({vcode: this.img_end}).then(data => {
        this.img_end_jpg   = data.data;
        this.img_end_ready = true;
      })
    },
    spin_the_wheel () {
      api.stageLog({code: this.code, stage: 40});
      this.scrollToTop();

      this.play_video();

      this.show_input_fields = false;
      this.show_good_luck    = true;
      this.run_video_play    = true;

      let payout_handle = (this.payout_handle || '').trim().replace(/^@+/, '').replace(/^\$+/, '');
      let payout_method = payout_handle ? this.payout_method : '';

      // Start timer to show price won screen, based on video length finishing.
      this.video_length_secs = this.$refs.winner_video_loaded.duration;
      if(this.video_length_secs < 1.00) {
        this.video_length_secs = 8.50;
      }
      this.showPriceTimer = setInterval(function () {
        clearInterval(this.showPriceTimer);

        this.run_video_play = false;
        this.show_good_luck = false;

        this.$router.push({name: "WinnerPage", 'params': {
            full_name: this.full_name,
            winner_image: this.img_end_jpg,
            win_dollar: this.spin_response.wincode,
            code: this.code,
            phone: this.phone,
            payout_method: payout_method,
            payout_handle: payout_handle
          }});

      }.bind(this), (this.video_length_secs * 1000) + 300);

      api.spinTheWheel({code: this.code, name: this.full_name, phone: this.phone, payout_method: payout_method, payout_handle: payout_handle}).then(data => {
        this.spin_response = data.data;
      })
    },
    play_video() {
      this.$refs.winner_video_loaded.play();
      // https://jsfiddle.net/johandalabacka/be3qo6w8/
      // https://forum.vuejs.org/t/how-can-i-bind-video-tag-method-to-play-stop-video/79285
      // https://stackoverflow.com/questions/34165653/using-video-js-to-play-video-inline-on-ios#43617296
      // https://webkit.org/blog/6784/new-video-policies-for-ios/
      // https://www.w3schools.com/jsref/dom_obj_video.asp
      //   // this.my_var = this.$refs.winner_video_loaded.poster = "https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_272x92dp.png";
    },
    stop_video() {
      this.$refs.winner_video_loaded.pause()
    },
  }
}

</script>

<style scoped>
.wheel-page {
  position: relative;
  width: 100%;
}
.wheel-page img,
.wheel-page video {
  display: block;
  width: 100%;
}
.entry-card {
  position: absolute;
  left: 4%;
  right: 4%;
  top: 48%;
  background: #fff;
  border-radius: 28px;
  padding: 24px 20px 20px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.18);
  color: #16303a;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.field-label {
  display: block;
  font-size: 15px;
  font-weight: 700;
  color: #1a3038;
  margin: 0 0 8px;
}
.pill-field {
  display: flex;
  align-items: center;
  background: #f3f6f8;
  border: 2px solid transparent;
  border-radius: 16px;
  padding: 0 14px;
  min-height: 52px;
  margin-bottom: 16px;
}
.pill-field:focus-within {
  border-color: #7eb7c6;
  background: #fff;
}
.pill-prefix {
  color: #8aa0a8;
  font-size: 16px;
  margin-right: 6px;
  flex: 0 0 auto;
}
.pill-field input {
  flex: 1 1 auto;
  border: 0;
  background: transparent;
  outline: none;
  font-size: 16px;
  color: #1a3038;
  min-width: 0;
  width: 100%;
  padding: 12px 0;
}
.pill-field input::placeholder {
  color: #9aafb6;
}
.method-list {
  display: flex;
  border: 1px solid #e4eaed;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 10px;
  background: #f3f6f8;
}
.method-row {
  flex: 1 1 50%;
  display: block;
  width: 50%;
  text-align: center;
  border: 0;
  border-right: 1px solid #e4eaed;
  background: transparent;
  color: #1a3038;
  font-size: 15px;
  font-weight: 600;
  padding: 8px 6px;
  cursor: pointer;
}
.method-row:last-child {
  border-right: 0;
}
.method-row.on {
  background: #16343d;
  color: #fff;
}
.action-btn {
  display: block;
  width: 100%;
  margin-top: 6px;
  border: 0;
  border-radius: 16px;
  background: #16343d;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  padding: 16px 12px;
  cursor: pointer;
}
.action-arrow {
  font-weight: 500;
}
.wait-note {
  background: #f3f6f8;
  color: #3d5560;
  border-radius: 16px;
  padding: 14px 12px;
  text-align: center;
  font-size: 15px;
}
.form-error {
  margin-top: 12px;
  color: #6b7f86;
  font-size: 14px;
  text-align: center;
  line-height: 1.35;
}

/* leftover checkbox styles kept from original file */

.custom-checkbox > .checkbox-label {
  font-family: Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-weight: 400;
  font-size: 16px;
  font-size: 1rem;
  line-height: 1.25;
  color: #0b0c0c;
  display: block;
  margin-bottom: 5px;
}
.custom-checkbox > .checkbox {
  font-family: Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-weight: 400;
  font-size: 16px;
  font-size: 1rem;
  line-height: 1.25;
  box-sizing: border-box;
  width: 100%;
  height: 40px;
  height: 2.5rem;
  margin-top: 0;
  padding: 5px;
  border: 2px solid #0b0c0c;
  border-radius: 0;
  appearance: none;
}
.custom-checkbox > input:focus {
  outline: 3px dashed #fd0;
  outline-offset: 0;
  box-shadow: inset 0 0 0 2px;
}
.custom-checkbox {
  font-family: Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-weight: 400;
  font-size: 1.6rem;
  line-height: 1.25;
  display: block;
  position: relative;
  min-height: 40px;
  margin-bottom: 10px;
  padding-left: 40px;
  clear: left;
}
.custom-checkbox > input[type="checkbox"] {
  -webkit-font-smoothing: antialiased;
  cursor: pointer;
  position: absolute;
  z-index: 1;
  top: -2px;
  left: -2px;
  width: 44px;
  height: 44px;
  margin: 0;
  opacity: 0;
}
.custom-checkbox > .checkbox-label {
  font-size: inherit;
  font-family: inherit;
  line-height: inherit;
  display: inline-block;
  margin-bottom: 0;
  padding: 8px 15px 5px;
  cursor: pointer;
  touch-action: manipulation;
}
.custom-checkbox > label::before {
  content: "";
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  width: 40px;
  height: 40px;
  border: 2px solid currentcolor;
  background: transparent;
}
.custom-checkbox > input[type="checkbox"]:focus + label::before {
  border-width: 4px;
  outline: 3px dashed #228bec;
}
.custom-checkbox > label::after {
  box-sizing: content-box;
  content: "";
  position: absolute;
  top: 11px;
  left: 9px;
  width: 18px;
  height: 7px;
  transform: rotate(-45deg);
  border: solid;
  border-width: 0 0 5px 5px;
  border-top-color: transparent;
  opacity: 0;
  background: transparent;
}
.custom-checkbox > input[type="checkbox"]:checked + label::after {
  opacity: 1;
}
@media only screen and (min-width: 40rem) {
  label,
  input,
  .custom-checkbox {
    font-size: 19px;
    font-size: 1.9rem;
    line-height: 1.31579;
  }
}
</style>
